"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isNil_1 = tslib_1.__importDefault(require("./isNil"));
/**
 * Checks if value is the type of object.
 *
 * @example
 * ```ts
 * isObject({}); // true
 * isObject([1, 2, 3]); // true
 * isObject(() => {}); // true
 * isObject(null); // false
 * isObject(123); // false
 * ```
 */
var isObject = function (input) {
    var type = typeof input;
    return !(0, isNil_1.default)(input) && (type === "object" || type === "function");
};
exports.default = isObject;
//# sourceMappingURL=isObject.js.map